import FilterReportDateItens from "../../../components/filter/reportDateItens/filter";
import reqVendaItem from "../../../services/reqMultiTenant/reqVendaItem";
import MainReportMatrix from "../matrix";

const ReportItemFaturamento = (props) => {
	const options = {
		title: "Produto por Faturamento",
		subTitle:
			"Relatório: custo = custo unitário * qtde vendida. \n Faturamento = custo - valor total vendido do produto.",
		ident: "productInvoicing", //usado para definir os event listners
		identFilter: "filterProductInvoicing", //usado para definir os event listners
		identReport: "reportProductInvoicing", //usado para definir os event listners
		tableColumns: [
			{ key: "nome", label: "Nome", align: "left" },
			{ key: "qtde", label: "Qtde.", align: "left" },
			{ key: "custo", label: "Custo", align: "center", format: "currency" },
			{ key: "faturamento", label: "Faturamento", format: "currency", align: "center" },
		],
		reportColumns: [
			{ key: "nome", label: "Nome", align: "left" },
			{ key: "qtde", label: "Qtde.", align: "left" },
			{ key: "custo", label: "Custo", align: "right", format: "currency" },
			{ key: "faturamento", label: "Faturamento", align: "right", format: "currency" },
		],
		showTime: true, //mostra a hora no filtro de data
		hasActive: false, //ativa o filtro de ativo
		hasSaleType: false, //ativa o filtro de tipo de venda
		parametersDate: [{ id: 1, label: "Data da venda", value: "dtVenda" }],
		parametersFilter: [
			{ id: 1, label: "Categoria", value: "categoria" },
			// { id: 2, label: "Grupo", value: "grupo" },
			// { id: 3, label: "SubGrupo", value: "subgrupo" },
			// { id: 4, label: "Fornecedor", value: "fornecedor" },
			{ id: 2, label: "Referência", value: "referencia" },
		],
		listDataTotal: [
			{ key: "total_faturamento", label: "Total do faturamento", format: "currency" },
			{ key: "total_bruto", label: "Total bruto", format: "currency" },
		], //usado para mostrar os totais na tela
	};

	const fetch = async (filterData, newPage, perPage = 15) => {
		const newFilterData = { ...filterData, page: newPage, perPage };

		const response = await reqVendaItem.itemFaturamento(newFilterData);

		return response;
	};

	//chama o relatório passando os options e a função fetch e o filtro de pesquisa
	return (
		<div className="flex flex-col mt-14 min-h-[calc(100vh-6.5rem)]">
			<MainReportMatrix options={options} fetch={fetch} FormFilter={FilterReportDateItens}></MainReportMatrix>
		</div>
	);
};

export default ReportItemFaturamento;
